export interface OutOfStockResponse {
    success: boolean;
    code: string;
    msg: string;
    data: boolean;
}
//订阅类型
export enum SubscribeType {
    OutOfStock = 0, //缺货提醒
}

//订阅状态
export enum SubscribeStatus {
    SUBSCRIBED = 1, //已订阅
    NOT_SUBSCRIBED = 0, //未订阅
}